export default __webpack_public_path__ + "static/media/github.98c60ddf.jpg";